








































































































import { Component } from 'vue-property-decorator';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignOpportunityDto from '@/models/CampaignOpportunities/CampaignOpportunityDto';
import CampaignContactStatus from '@/components/CampaignContacts/Display/CampaignContactStatus.vue';
import CampaignStatusEnum from '@/models/Campaigns/CampaignStatus';
import CampaignContactStatusEnum from '@/models/CampaignContacts/CampaignContactStatus';
import { campaignOpportunitySkippedReasonLabel } from '@/models/CampaignOpportunities/CampaignOpportunitySkippedReason';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'CampaignOpportunities',
  components: { CampaignContactStatus }
})
export default class extends GiganautVue {

	campaignStatusEnum = CampaignStatusEnum;
	page = 1;
	perPage = 8;

	get campaign() {
		return CampaignDetailsModule.currentCampaign;
	}

	get selectedCampaignOpportunity() {
		return CampaignDetailsModule.campaignOpportunitiesVM.selectedCampaignOpportunity;
	}

	set selectedCampaignOpportunity(value: CampaignOpportunityDto) {
		CampaignDetailsModule.campaignOpportunitiesVM.selectedOpportunityId = value.opportunityId;
		CampaignDetailsModule.campaignOpportunitiesVM.selectedCampaignOpportunity = value;
	}

	get opportunity() {
		return this.selectedCampaignOpportunity.opportunity;
	}

	get venueTypeName(): string {
		const o = this.opportunity;
		return o && o.prospectLocationType ? o.prospectLocationType.name : '';
	}

	// Human-readable skip reason for a recipient that was skipped at send time
	// (e.g. the opportunity was won/closed). Empty for non-skipped recipients.
	skipReasonLabel(campaignOpportunity: CampaignOpportunityDto | null): string {
		if (!campaignOpportunity || campaignOpportunity.status !== CampaignContactStatusEnum.Skipped) return '';
		return campaignOpportunitySkippedReasonLabel(campaignOpportunity.emailSkippedReason);
	}

	get campaignOpportunities() {
		return CampaignDetailsModule.campaignOpportunitiesVM.campaignOpportunities;
	}

	get pagedCampaignOpportunities() {
		return this.campaignOpportunities.slice((this.page - 1) * this.perPage, this.page * this.perPage);
	}

	async onPageChanged() {
		if (this.pagedCampaignOpportunities.length > 0) {
			CampaignDetailsModule.campaignOpportunitiesVM.selectedCampaignOpportunity = this.pagedCampaignOpportunities[0];
		}
	}

	async removeOpportunityFromAudience() {
		const options: VuetifyConfirmObject = {
			buttonTrueText: 'REMOVE',
			buttonFalseText: 'CANCEL',
			buttonTrueColor: 'primary',
			buttonFalseColor: 'primary',
		};
		const result = await this.$confirm('Are you sure you want to remove this opportunity contact from the audience?', options);
		if (result) {
			await CampaignDetailsModule.deleteCampaignOpportunity(this.selectedCampaignOpportunity.id);
		}
	}
}
